<template>
  <div>

    <div class="title-section">
      <div class="display-1 font-weight-bold">{{meta.title}}</div>
      <div class="subheading">{{meta.subtitle}}</div>
    </div>


    <v-divider class="spacer"/><div class="headline font-weight-bold">Texturing!</div><v-divider class="div-after"/>
    <div class="body-1">
      A smaller update while I continue working on some other project work, as well as a rewrite of this project.
      Checkerboard textures!
    </div>
    <v-img class="u-image" :src="require(`../assets/updates/7/checkerboard.png`)"/>
      <div class="font-weight-medium">Rendering with a procedural checkerboard texture</div>
    <v-img class="u-image" :src="require(`../assets/updates/7/ground.png`)"/>
      <div class="font-weight-medium">And an image based ground texture</div>
    <v-img class="u-image" :src="require(`../assets/updates/7/grass.png`)"/>
      <div class="font-weight-medium">And some grass!</div>
    <v-img class="u-image" :src="require(`../assets/updates/7/art.png`)"/>
      <div class="font-weight-medium">And some album artwork</div>


  </div>
</template>

<script>
import CardList from '../components/CardList';

export default {
  name: 'U_7',
  components: { CardList, },
  data() {
    return {
    };
  },
  computed: {
    meta() {
      return this.$store.state.updates[7];
    },
  },
}
</script>

<style>

</style>
